import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';

function CoinvestorInvestmentInfo({
    formikProps,
    commissionRateGroup,
    agencyRole,
}) {
    const { t } = useTranslation();
    const showOverchargeSection = agencyRole === 'COINVESTOR' || agencyRole === 'INVESTOR';

    const renderEnergyField = (fieldName, label) => (
        <KTFormGroup
            label={
                <span
                    className="font-weight-boldest"
                    style={{
                        fontSize: 13,
                        color: AppColors.gray[800],
                    }}
                >
                    {label}
                </span>
            }
            inputName={fieldName}
            additionalClassName=" mb-3"
            inputElement={
                <FastField name={fieldName}>
                    {({ field, form, meta }) => (
                        <KTFormInput
                            name={field.name}
                            value={field.value}
                            onChange={(value) => {
                                form.setFieldValue(field.name, value);
                            }}
                            onBlur={() => {
                                form.setFieldTouched(field.name, true);
                            }}
                            enableCheckValid
                            type={KTFormInputType.currency}
                            placeholder={'Nhập số'}
                            isValid={_.isEmpty(meta.error)}
                            isTouched={meta.touched}
                            feedbackText={meta.error}
                            unit="VNĐ/kWh"
                        />
                    )}
                </FastField>
            }
        />
    );

    const renderOverchargeField = () => (
        <KTFormGroup
            label={
                <span
                    className="font-weight-boldest"
                    style={{
                        fontSize: 13,
                        color: AppColors.gray[800],
                    }}
                >
                    {t('Dành cho ô tô')}
                </span>
            }
            inputName="overchargeCommissionValue"
            additionalClassName=" mb-3"
            inputElement={
                <FastField name="overchargeCommissionValue">
                    {({ field, form, meta }) => (
                        <KTFormInput
                            name={field.name}
                            value={field.value}
                            onChange={(value) => {
                                form.setFieldValue(field.name, value);
                            }}
                            onBlur={() => {
                                form.setFieldTouched(field.name, true);
                            }}
                            enableCheckValid
                            type={KTFormInputType.currency}
                            placeholder={'Nhập số'}
                            isValid={_.isEmpty(meta.error)}
                            isTouched={meta.touched}
                            feedbackText={meta.error}
                            unit="VNĐ/phút"
                        />
                    )}
                </FastField>
            }
        />
    );

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Doanh thu theo kW điện bán ra
                    </span>
                </Modal.Title>
            </Col>
            <Col md={6} className="pr-2">
                {renderEnergyField('energyCommissionForCar', t('Dành cho ô tô'))}
            </Col>
            {showOverchargeSection && (
                <>
                    <Col md={12}>
                        <div
                            className="my-2"
                            style={{
                                borderBottom: `1px dashed ${AppColors.gray[300]}`,
                            }}
                        />
                    </Col>
                    <Col md={12}>
                        <Modal.Title className="mb-3">
                            <span
                                className="font-weight-bolder"
                                style={{ fontSize: 18, color: AppColors.gray[900] }}
                            >
                                Doanh thu theo số phút sạc quá giờ
                            </span>
                        </Modal.Title>
                    </Col>
                    <Col md={6} className="pr-2">
                        {renderOverchargeField()}
                    </Col>
                </>
            )}
        </Row>
    );
}

export default CoinvestorInvestmentInfo;
